import { Component, h } from '@stencil/core';

@Component({
  tag: 'signet-progress',
  styleUrl: 'signet-progress.scss',
  shadow: true,
})
export class SignetProgress {
  render() {
    return (
      <div class="signet-progress">
        <slot></slot>
      </div>
    );
  }
}
